import { Component, OnInit } from '@angular/core';
import { ContractorType } from '../contractor-type';
import { ContractorTypeService } from '../contractor-type.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contractor-type',
  templateUrl: './contractor-type.component.html',
  styleUrls: ['./contractor-type.component.css'],
  providers: [ContractorTypeService]
})
export class ContractorTypeComponent implements OnInit {

  contractorTypes: ContractorType[];	
  loading: boolean = false;

  constructor(private contractorTypeService: ContractorTypeService, private router: Router) { 

  }

  ngOnInit() {
        this.loading = true;
  		  this.contractorTypeService.getContractorTypeList().subscribe(response=> {this.contractorTypes=response['data'];this.loading= false;});
  }

  clicked():void {
   		this.router.navigate(['dashboard/contractor-type-crud']);
  }  

  clickedId(id: any){
    	 this.router.navigate(['dashboard/contractor-type-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractor_types/contractor-type/contractor-type.component.ts